import React from 'react';
import { format, parseISO } from 'date-fns';
import { Column } from '../../../../hooks/useTablePages';
import Icon from '../../../../components/Icon/Icon';
import { MyCompany } from './CompanyProfile';
import { constantToLabel } from '@ecosconnect/core/src/helpers/string';
import { Flex } from 'rebass';

type Credential = MyCompany['credentials'][number];

const columns: Column[] = [
  {
    header: 'Number',
    id: 'value',
    accessor: (row: Credential) => (
      <Flex flexDirection="row" alignItems="center" sx={{ gap: 1 }}>
        {row.value}
        {row.image && (
          <Icon title={row.image.contentType} icon="file" size="16" />
        )}
      </Flex>
    ),
    stringAccessor: (row: Credential) => row.value,
    width: 190,
  },
  {
    header: 'Issuer',
    id: 'issuer',
    accessor: (row: Credential) => {
      if (row.issuer === 'STATE' || row.issuer === 'COUNTY') {
        return row.state;
      }
      if (row.issuer === 'CITY') {
        return `${row.city}, ${row.state}`;
      }
      if (row.issuer === 'WATER_SUPPLIER') {
        return constantToLabel(row.issuer);
      }
      return row.issuer;
    },
    width: 190,
  },
  {
    header: 'Issued',
    id: 'issued',
    accessor: (row: Credential) => {
      if (!row.issueDate) {
        return '';
      }
      return String(format(parseISO(row.issueDate), 'MMM d yyyy'));
    },
    width: 102,
  },
  {
    header: 'Expires',
    id: 'expires',
    accessor: (row: Credential) => {
      if (!row.expireDate) {
        return '';
      }
      return String(format(parseISO(row.expireDate), 'MMM d yyyy'));
    },
    width: 102,
  },
];

export default columns;

// Should this move to the Gauges directory?
